module.exports = __webpack_public_path__ + "img/Wp_2053.fcf95ce9.png";